export const Globus = () => (
  <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.0013 17.7082C14.2585 17.7082 17.7096 14.257 17.7096 9.99984C17.7096 5.74264 14.2585 2.2915 10.0013 2.2915M10.0013 17.7082C5.74411 17.7082 2.29297 14.257 2.29297 9.99984C2.29297 5.74264 5.74411 2.2915 10.0013 2.2915M10.0013 17.7082C8.04529 17.7082 6.45964 14.257 6.45964 9.99984C6.45964 5.74264 8.04529 2.2915 10.0013 2.2915M10.0013 17.7082C11.9573 17.7082 13.543 14.257 13.543 9.99984C13.543 5.74264 11.9573 2.2915 10.0013 2.2915M17.5013 9.99984H2.5013"
      stroke="#7A7A83"
      strokeWidth="1.5"
      strokeLinecap="square"
    />
  </svg>
)

export default Globus
